// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

// display_name / rel_type_id / co_type_id are the machine identifiers the Segments CO filter
// consumes and MUST stay required. The label/cardinality fields are additive: keep them tolerant
// (maybe) so that during a rolling deploy a response from an older backend that omits them still
// validates — otherwise the whole response is rejected, taking the machine identifiers down with it.
export const isGetCustomObjectsUserCustomObjectTypeRelationshipsResult = objectOf({
  items: arrayOf(
    objectOf({
      display_name: string,
      rel_type_id: number,
      co_type_id: number,
      forward_name: maybe(string),
      forward_name_plural: maybe(string),
      reverse_name: maybe(string),
      reverse_name_plural: maybe(string),
      cardinality: maybe(string),
    })
  ),
});
